

const pokemonApi = "https://pokeapi.co/api/v2/pokemon";

export { pokemonApi };